/**
 * Converts ASCII digits (0-9) to Persian/Farsi digits (۰-۹).
 * Used for RTL-safe number display in Persian UI.
 */
export function formatPersianNumber(n: number): string {
  return n
    .toString()
    .replace(/\d/g, (d) => String.fromCharCode(0x06f0 + Number(d)));
}

const PERSIAN_ORDINAL_WORDS: Readonly<Record<number, string>> = {
  1: "اول",
  2: "دوم",
  3: "سوم",
  4: "چهارم",
  5: "پنجم",
  6: "ششم",
  7: "هفتم",
  8: "هشتم",
  9: "نهم",
  10: "دهم",
  11: "یازدهم",
  12: "دوازدهم",
  13: "سیزدهم",
  14: "چهاردهم",
  15: "پانزدهم",
  16: "شانزدهم",
  17: "هفدهم",
  18: "هجدهم",
  19: "نوزدهم",
  20: "بیستم",
  21: "بیست و یکم",
};

/**
 * Persian ordinal *word* for a 1-based position — اول, دوم, سوم, … instead of
 * 1, 2, 3. Falls back to digit form for ranks beyond the lookup table (DAO
 * Election runs at most 21 candidates per cycle, so the table covers all
 * realistic uses; the fallback exists only for safety, not as expected UX).
 */
export function formatPersianOrdinal(n: number): string {
  const word = PERSIAN_ORDINAL_WORDS[n];
  return word ?? formatPersianNumber(n);
}
